<template>
  <div
    :class="{
      'transparent-header': ['how-gloveler-works'].includes($route.name),
    }"
  >
    <portal-target name="top"></portal-target>
    <header id="myHeader" :class="{ 'inner-pg-header': innerHeader }">
      <b-navbar toggleable="lg">
        <b-navbar-toggle target="nav-text-collapse"
          ><i class="fa fa-bars" aria-hidden="true"></i
        ></b-navbar-toggle>

        <b-navbar-brand>
          <component
            :is="
              currentConfigKey('logoLink', '/').startsWith('/')
                ? 'router-link'
                : 'a'
            "
            :to="currentConfigKey('logoLink', '/')"
            :href="currentConfigKey('logoLink', '/')"
          >
            <img :src="currentConfigKey('logo')" class="app-logo" alt="" />
          </component>
        </b-navbar-brand>

        <b-collapse id="nav-text-collapse" is-nav ref="navBar">
          <b-navbar-nav @click="handleClick()">
            <b-nav-text v-if="currentConfigKey('navLinks.propertyList')"
              ><router-link to="/listing">{{
                $t("header.propertyList")
              }}</router-link></b-nav-text
            >
            <b-nav-text v-if="currentConfigKey('navLinks.howItWorks')">
              <router-link to="/how-gloveler-works">{{
                $t("header.howGlovelerWorks")
              }}</router-link>
            </b-nav-text>
            <b-nav-text
              v-for="{ titleKey, url, newTab } in currentConfigKey(
                'customNavLinks',
                []
              )"
              :key="titleKey"
            >
              <a :href="url" :target="newTab ? '_blank' : '_self'">{{
                $t(titleKey)
              }}</a>
            </b-nav-text>
            <b-nav-text
              @click="openHelp"
              v-if="currentConfigKey('navLinks.help')"
              ><a href="#">{{ $t("header.help") }}</a></b-nav-text
            >
            <b-nav-text v-if="currentConfigKey('navLinks.map')"
              ><router-link to="/listing_map">{{
                $t("header.map")
              }}</router-link></b-nav-text
            >
            <b-nav-text v-if="currentConfigKey('navLinks.login')"
              ><a
                href="https://admin.gloveler.com/login"
                target="_blank"
                class="login"
                ><b-button class="g-secondary-button">{{
                  $t("header.login")
                }}</b-button></a
              ></b-nav-text
            >
            <b-nav-text v-if="currentConfigKey('navLinks.register')"
              ><a
                href="https://admin.gloveler.com/register"
                target="_blank"
                class="register"
                ><b-button class="g-secondary-button">{{
                  $t("header.register")
                }}</b-button></a
              ></b-nav-text
            >
            <li class="lang-selector-item" v-if="$route.name">
              <b-dropdown right class="m-md-2 lang-selector">
                <template #button-content>
                  {{ getLocale }}
                  <b-spinner
                    v-if="resettingLocale"
                    class="button-spinner"
                    label="Spinning"
                  ></b-spinner>
                </template>
                <b-dropdown-item
                  v-for="{ code, title } of supportedLocales"
                  :key="code"
                  @click="changeLanguage(code)"
                  :class="{ 'lang-divider': code === langDivider }"
                >
                  <hr v-if="code === langDivider">
                  <span v-else>{{ title | capitalize }}</span>
                </b-dropdown-item>
              </b-dropdown>
            </li>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </header>
    <b-breadcrumb v-if="innerHeader">
      <b-breadcrumb-item :to="getHomePath()">
        {{ $t("breadcrumbs.home") }}
      </b-breadcrumb-item>
      <b-breadcrumb-item
        v-for="{ title, path } of breadcrumbs"
        :key="title"
        :to="getBreadcrumbPath(path)"
        :href="path === '#' ? '#' : undefined"
        >{{ title }}</b-breadcrumb-item
      >
    </b-breadcrumb>
    <button class="d-none" id="zammad-feedback-form">Feedback</button>
  </div>
</template>

<script>
const LANGUAGE_DIVIDER = "xx";
import { mapState } from "vuex";
import TranslationHelper from "../helpers/translation";
import { loadScript } from "../helpers/loadScript";
import { defaultListId } from "../shared";
import { currentConfigKey } from "../helpers/theme";
export default {
  name: "Header",
  components: {},
  data() {
    return {
      locale: "en",
      resettingLocale: false,
      innerHeader: true,
      langDivider: LANGUAGE_DIVIDER,
    };
  },

  created() {
    if (this.$route.name == "home") {
      this.innerHeader = false;
    }
  },

  computed: {
    ...mapState("config", ["currentListId"]),
    supportedLocales() {
      const locales = TranslationHelper.getLocales();
      const supportedLocales = currentConfigKey("supportedLanguages", []);
      const supportedArray = Array.isArray(supportedLocales)
        ? supportedLocales
        : [];

      if (!supportedArray.length) {
        return locales;
      }

      return supportedArray
        .map((code) => {
          if (code === LANGUAGE_DIVIDER) {
            return { code, title: ""};
          }
          return locales.find((locale) => locale.code === code);
        })
        .filter(Boolean);
    },
    locales() {
      const languages = Object.entries(this.$t("langs")).map(
        ([code, name]) => ({
          code: code,
          title: name,
        })
      );
      return languages;
    },
    getLocale() {
      const locales = TranslationHelper.getLocales();
      const locale = locales.find(({ code }) => code === this.locale);
      return locale ? locale.title : "English";
    },
    breadcrumbs() {
      let breadcrumbs = [];

      if (this.$route.name === "listing") {
        breadcrumbs.push({
          title: this.$t("breadcrumbs.listing"),
          path: "#",
        });
      }
      if (this.$route.name === "reservation-success") {
        breadcrumbs.push(
          {
            title: this.$t("breadcrumbs.listing"),
            path: { path: "/listing" },
          },
          {
            title: this.$t("breadcrumbs.reservationSuccess"),
            path: "#",
          }
        );
      }
      if (this.$route.name === "how-gloveler-works") {
        breadcrumbs.push({
          title: this.$t("breadcrumbs.howGlovelerWorks"),
          path: "#",
        });
      }
      if (this.$route.name === "listing-details") {
        breadcrumbs.push({
          title: this.$t("breadcrumbs.listingDetails"),
          path: "#",
        });
      }
      return breadcrumbs;
    },
  },

  async mounted() {
    const locale = localStorage.getItem("locale");
    this.locale = locale || "en";
    if (!window.jQuery) {
      const jqueryModule = await import("jquery");
      const jquery = jqueryModule.default || jqueryModule;
      window.jQuery = window.$ = jquery;
    }
    try {
      await loadScript("https://zammad.cultuzz.com/assets/form/form.js", {
        id: "zammad_form_script",
      });
    } catch (e) {
      console.warn("Zammad form script failed to load", e);
      return;
    }
    this.$nextTick(() => {
      // eslint-disable-next-line no-undef
      if (typeof window.jQuery === "undefined" || !window.jQuery.fn.ZammadForm) {
        return;
      }
      const messageTitle = `How to Contact ${currentConfigKey("title")}`;
      // eslint-disable-next-line no-undef
      window.jQuery(function () {
        // eslint-disable-next-line no-undef
        window.jQuery("#zammad-feedback-form").ZammadForm({
          messageTitle,
          messageSubmit: "Send Message",
          messageThankYou:
            "Thank you for your inquiry (#%s)! We'll contact you as soon as possible.",
          modal: true,
          showTitle: true,
          attachmentSupport: true,
        });
      });
    });
  },

  methods: {
    currentConfigKey,
    getHomePath() {
      const basePath = this.currentListId !== defaultListId ? "/listing" : "/";
      return basePath;
    },
    getBreadcrumbPath(path) {
      if (path === "#") {
        return undefined;
      }
      if (typeof path === "object" && path !== null) {
        return path;
      }
      return path;
    },
    async changeLanguage(locale) {
      const locales = TranslationHelper.getLocales();
      const localeData = locales.find(({ code }) => code === locale);
      if (!localeData) {
        return;
      }
      const currentLocale = localStorage.getItem("locale");
      localStorage.setItem("locale", locale);
      this.locale = locale;
      if (currentLocale === locale) {
        this.resettingLocale = true;
        try {
          await TranslationHelper.updateTranslations(
            this.$router,
            locale,
            true
          );
        } catch (e) {
          console.log(e.message);
        } finally {
          this.resettingLocale = false;
        }
      }
      this.$router.go(0);
    },
    handleClick() {
      if (this.$refs.navBar.show == true) {
        this.$root.$emit("bv::toggle::collapse", "nav-text-collapse");
      }
    },
    openHelp() {
      document.getElementById("zammad-feedback-form").click();
    },
  },

  watch: {
    $route() {
      if (this.$route.name == "home") {
        this.innerHeader = false;
      } else this.innerHeader = true;
      if (this.$refs.navBar.show == true) {
        this.$root.$emit("bv::toggle::collapse", "nav-text-collapse");
      }
    },
  },
};
</script>

<style>
.app-logo {
  width: var(--logo-width);
  @media (max-width: 768px) {
    width: var(--logo-width-mobile);
  }
}
.zammad-form h2 {
  text-transform: uppercase;
  color: #ff762b;
  font-weight: bolder;
  font-size: 27px;
}
.zammad-form button {
  width: 100%;
  background: #ff762b;
  color: white;
  padding: 10px;
}
.lang-divider, .lang-divider hr, .lang-divider a {
  margin: 0;
  padding: 0;
}
</style>
